import { Months } from "../utils/contants/months";

export function getCurrentMonthByDate(date: string): string {
  const dateFormat = new Date(date);
  const newDate = new Date(dateFormat.setHours(dateFormat.getHours() + 3));

  const monthNumber = newDate.getMonth() + 1;

  return Months.find((row) => row.number === monthNumber)?.label || "";
}